import { createFileRoute, useRouter } from '@tanstack/react-router';
import { SellTable } from '@/components/Pages/Sells/SellTable';
import { Box, Button } from '@mui/joy';
import { Add as AddIcon } from '@mui/icons-material';

export const Route = createFileRoute('/_protected/sells/')({
  component: SellsPage,
});

function SellsPage() {
  const router = useRouter();

  const handleCreateSell = () => {
    router.navigate({ to: '/sells/create' });
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
        <Button startDecorator={<AddIcon />} onClick={handleCreateSell}>
          Crear pedido
        </Button>
      </Box>

      <SellTable />
    </Box>
  );
}
